import React from "react"
import Layout from "../components/layout"
import { StaticNewsBar } from "../components/Newsbar"
import Seo from "../components/seo"
import { PlayHQData } from "../components/Playhq"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { graphql, Link } from "gatsby"
import PromoSlider from "../components/PromoSlider"
import ShopifySidebar from "../components/ShopifySidebar"

const TeamPageTemplate = ({pageContext, data}) => {
  const { fixture } = pageContext
  let { wpClub, team } = data

  wpClub = wpClub ?? {};
  wpClub.slug = wpClub.slug ?? '';
  wpClub.acf = wpClub.acf ?? {};
  wpClub.acf.logo = wpClub.acf.logo ?? 'https://wolfpackbasketball.com.au/_gatsby/image/85a677d7a74c21802e4a3d102120973c/066a53430beb8eb2cd1030e839ba88a4/WBA-Green.avif';
  wpClub.acf.colorA = wpClub.acf.colorA ?? '#9999';
  wpClub.acf.colorB = wpClub.acf.colorB ?? '#9a9a9a';

  if (wpClub.slug.length == 0) {
    return ;
  }
  // const { logo, colorA, colorB } = wpClub.acf
  const {
    logo = 'https://wolfpackbasketball.com.au/_gatsby/image/85a677d7a74c21802e4a3d102120973c/066a53430beb8eb2cd1030e839ba88a4/WBA-Green.avif',
    colorA = '#9999',
    colorB = '#9a9a9a',
  } = (wpClub && wpClub.acf) || {};

  if (wpClub && typeof wpClub.slug === 'undefined') {
      wpClub.slug = '';
  }
  
  const pageTitle = team.name;
  const isJunior = team.isJunior;
  const clubName = wpClub?.slug;

  const group = team.group;
  let wpData, clubLogo;
  if (isJunior) {
    wpData = wpClub ? wpClub.acf : null;
    clubLogo = logo?.gatsbyImage;
  }
  const Breadcrumbs = () => {
    const path = [
      {
        text: "Teams",
        link:"/teams"
      },
      {
        text: 'SDC',
        link: '/teams/senior'
      },
      {
        text: pageTitle,
        link: "#"
      },
    ]
    if (isJunior) {
      path[1] = {
        text: clubName[0].toUpperCase() + clubName.slice(1, clubName.length),
        link: `/clubs/${pageContext.clubSlug}`,
      };
      path[2] = {
        text: group[0].toUpperCase() + group.slice(1, 3),
        link: "#"
      };
    }
    return (
      <>
        <div className={`team-breadcrumbs w-full flex bg-slate-900 ${isJunior ? "junior" : "default" }` }>
          <div className="breadcrumbs-inner flex flex-row flex-nowrap space-between mx-auto ">
            {
              path.map( (crumb, i) => {
              if (i !== path.length - 1) {
                return (
                <>
                  <div className="breadcrumb-text" key={i} >
                    <Link to={crumb.link} className="h-full w-full">
                      <p> {crumb.text} </p>
                    </Link>
                  </div>
                  <ArrowRightIcon key={'a'+ i} className="mx-1 breadcrumb-icon" />
                </>
                )
              }
              else return (
                <div className="breadcrumb-text" key={i} >
                  <strong>{crumb.text}</strong>
                </div>
              )
              })
            }
          </div>
        </div>
      </>
      )
  }
  switch (isJunior) {
    case true: return (
      <Layout>
        <div className="team-page-layout">
          <div className={`team-banner ${wpClub.slug}`} style={{backgroundColor: colorA}}>
            <div className="team-club-image" style={{
              backgroundImage: `linear-gradient(to-left,${colorA},rgba(240,240,240,0.1))`
            }}>
                <Link to={`/clubs/${pageContext.clubSlug}`}>
                  <GatsbyImage
                    className="club-image"
                    image={clubLogo}
                    alt={`Logo for ${team.name}`}
                    objectFit="scale-down"
                  />
                </Link>
              </div>
              <div className="junior-domestic-image">
                <Link href="/teams">
                  <StaticImage
                    src="../images/JDC-White-alpha.png"
                    alt="Junior Domestic Comp. logo for Wanneroo Basketball Association"
                  />
                </Link>
              </div>
            <h1 style={{ color: colorB }}>{team.name}</h1>
          <Breadcrumbs />
          </div>
          <div className="team-page-grid">
            <ShopifySidebar />
            <StaticNewsBar />
            <div className="team-content">
              <PlayHQData teamData={team} fixtureData={fixture} colors={[colorA,colorB]}/>
            </div>
          </div>
        </div>
        <PromoSlider />
      </Layout>
    )
    case false: return (
      <Layout>
        <div className="">
          <div className="team-banner default">
            <span className="banner-stripe"></span>
            <div className="team-club-image">
              <StaticImage
                className="club-image"
                src="../images/logos/SeniorDomesticLogo-small.png"
                alt={`Logo for Senior Domestic Competition`}
              />
            </div>
            <h1 className="team-name">{team.name}</h1>
          </div>
          <Breadcrumbs />
          <div className="team-page-grid">
            <ShopifySidebar />
            <StaticNewsBar />
            <div className="team-content">
              <PlayHQData teamData={team} fixtureData={fixture} colors={[colorA, colorB]} />
            </div>
          </div>
        </div>
        <PromoSlider />
      </Layout>
    )
    default: return (
      <Layout>
        <div className="oops">
          <p>It seems something went wrong. <Link to="/">Click here to return Home.</Link> </p>
        </div>
      </Layout>
    )
  }
}
export const Head = ({ data }) =>
  <Seo
    title={data.team?.name}
    description={`Results & Statistics for ${data.team?.name || "unavailable"}`}
  />

export default TeamPageTemplate

export const query = graphql`
  query TeamPageQuery($clubSlug: String!,$name: String!) {
    wpClub(slug: {eq: $clubSlug}) {
      slug
      acf: clubFields {
        colorA
        colorB
        logo {
          gatsbyImage(width: 175, aspectRatio: 1)
        }
      }
    }
    team:teams(name: {eq: $name}) {
      name
      phqId
      group
      isJunior
      grade {
        name
        phqId
      }
    }
  }
`
